import { useEffect, useState } from "react";
import { activeEvent, upcomingEvent, type EventInfo } from "@greg-chick/shared";
import { loadEvents } from "../event/eventData";
import { loadAssetManifest, manifestEntry } from "../lib/assetManifest";
import { safeImageUrl } from "../lib/safeUrl";
import { useExternalLink } from "./externalLink";
import { formatKst } from "@greg-chick/shared";

// 랜딩 이벤트 배너(FR-LAND-03) — content/events.yaml 기반. 비개발자 갱신 가능.
// 진행 중 행사 우선, 없으면 다가오는 행사. 신청은 외부 폼(보호자 작성, FR-COM-04 고지).
function formatWhen(iso?: string): string {
  // 🕘 한국 시각으로(기기 시간대 아님 — UTC 태블릿에서 행사 시각이 9시간 밀려 보였다 · kstTime.formatKst)
  return formatKst(iso, {
      month: "long",
      day: "numeric",
    });
}

export function EventBanner() {
  const [evt, setEvt] = useState<EventInfo | null>(null);
  const [live, setLive] = useState(false);
  // 운영자가 관리자에서 올리는 행사 그림(event.banner). 없으면 글자만 나온다 —
  // 예전엔 이 슬롯을 아무도 안 읽어서, 올려도 화면에 나오지 않는 **빈 업로드 칸**이었다.
  const [pic, setPic] = useState<string | undefined>(undefined);
  const requestExternal = useExternalLink((s) => s.request);

  useEffect(() => {
    let alive = true;
    void loadEvents().then((list) => {
      if (!alive) return;
      const now = Date.now();
      const active = activeEvent(list, now);
      setEvt(active ?? upcomingEvent(list, now));
      setLive(active !== null);
    });
    void loadAssetManifest().then((m) => {
      if (alive) setPic(safeImageUrl(manifestEntry(m, "event.banner")?.url));
    });
    return () => {
      alive = false;
    };
  }, []);

  if (!evt) return null;

  return (
    <div className="event-banner" role="region" aria-label="행사 안내">
      {/* 글자 뒤가 아니라 왼쪽 동그란 자리에 — 글자 대비를 그림이 흔들지 않게(FR-COM-06) */}
      {/* 🔴 크기를 적어 둔다 — 없으면 그림이 올 때 줄이 밀린다. 34px 로 그리는 자리라
          큰 그림을 올리면 첫 화면만 무거워진다(`pnpm check:artres` 의 UI_FIXED 가 잡는다). */}
      {pic ? (
        <img
          className="event-banner__pic"
          src={pic}
          alt=""
          width={34}
          height={34}
          loading="lazy"
          draggable={false}
        />
      ) : null}
      <span className={`event-banner__tag${live ? " event-banner__tag--live" : ""}`}>
        {live ? "진행 중" : "예정"}
      </span>
      <span className="event-banner__title">{evt.title}</span>
      {evt.start && !live ? (
        <span className="event-banner__when">{formatWhen(evt.start)}</span>
      ) : null}
      {evt.applyUrl ? (
        <button
          type="button"
          className="event-banner__apply"
          onClick={() => requestExternal(evt.applyUrl!)}
        >
          참가 신청 ↗
        </button>
      ) : null}
    </div>
  );
}
